/** Disease model filter options for GDA evidence (26.3), ordered by frequency. */
export const DISEASE_MODEL_GDA = [
  'Patient studies',
  'Mouse',
  'Biospecimens',
  'Primary cells',
  'Population studies',
  'Human Studies',
  'Cancer cell lines',
  'Cell Line Models',
  'In Vivo',
  'In Vitro',
  'Rat',
  'Models',
  'Loss-of-function',
  'Animal Models',
  'Epidemiological studies',
  'Transgenic',
  'Humanized models',
  'Data-driven models',
  'Non-cancer cell lines',
  'Clinical trials',
  'Generic cell lines',
  'Dog',
  'Rodents',
  'Zebrafish',
  'Genetic Models',
  'Stem cell models',
  'Drosophila',
  'Computational Models',
  'Other non-rodent mammals',
  '3D cultures',
  'Ex Vivo Systems',
  'iPSC models',
  'Organoids',
  'Embryonic stem cell models',
  'Mechanistic models',
  'Surgical models',
  'Gain-of-function',
  'C. elegans',
  'Pig',
  'Other rodents',
  'Rabbit',
  'Other vertebrates',
  'Physiological assays',
  'Yeast',
  'Organotypic cultures',
  'Macaque',
  'Non-human primates',
  'Co-culture systems',
  'Xenopus',
  'Invertebrates',
  'Tissue slices',
  'Other NHP',
  'Microphysiological systems',
  'Electronic Health Records',
  'Marmoset',
  'Biobanks',
  'Behavioural tests',
  'Perfused organs',
  'Human-derived Systems',
  'Behavioural and functional assays',
  'Non-mammalian vertebrates',
  'Non-rodent mammals',
  'Advanced In Vitro',
  'Other model organisms',
] as const;

/** Disease model filter options for VDA evidence (26.3), ordered by frequency. */
export const DISEASE_MODEL_VDA = [
  'Patient studies',
  'Population studies',
  'Data-driven models',
  'Mouse',
  'Epidemiological studies',
  'Biospecimens',
  'Genetic Models',
  'Transgenic',
  'In Vitro',
  'Models',
  'Human Studies',
  'Primary cells',
  'In Vivo',
  'Cancer cell lines',
  'Cell Line Models',
  'Gain-of-function',
  'Computational Models',
  'Clinical trials',
  'iPSC models',
  'Mechanistic models',
  'Rat',
  'Loss-of-function',
  'Non-cancer cell lines',
  'Animal Models',
  'Humanized models',
  'Generic cell lines',
  'Zebrafish',
  'Drosophila',
  'Dog',
  'C. elegans',
  'Organoids',
  'Pig',
  'Embryonic stem cell models',
  'Rodents',
  '3D cultures',
  'Ex Vivo Systems',
  'Physiological assays',
  'Other non-rodent mammals',
  'Macaque',
  'Yeast',
  'Xenopus',
  'Rabbit',
  'Behavioural and functional assays',
  'Other vertebrates',
  'Other NHP',
  'Co-culture systems',
  'Invertebrates',
  'Other rodents',
  'Stem cell models',
  'Human-derived Systems',
  'Microphysiological systems',
  'Non-human primates',
  'Organotypic cultures',
  'Surgical models',
] as const;

export const SEX_OPTIONS = ['Female', 'Male', 'Transgender woman', 'Transgender man'] as const;
